import type { FC } from 'react';

import { useTranslation } from '@crehana/i18n';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { PrimaryButton } from '@crehana/ui';

import { useAttributes } from '@/views/AdminDashboard/components/AttributesDrawer/hooks';

import { BeautyButton, Divider, FooterWrapper } from './Footer.styles';

interface headerProps {
  currentStep: number;
  isDark?: boolean;
  handleBackStep: () => void;
  handleNextStep: () => void;
  closeDrawer: () => void;
}

const Footer: FC<React.PropsWithChildren<headerProps>> = ({
  currentStep,
  isDark,
  handleBackStep,
  handleNextStep,
  closeDrawer,
}) => {
  const { t } = useTranslation();
  const { attributes } = useAttributes();

  return (
    <>
      {currentStep !== 4 && (
        <FooterWrapper isDark={isDark}>
          <BeautyButton
            className="font-button mr-40"
            onClick={currentStep > 1 ? handleBackStep : closeDrawer}
          >
            {currentStep > 1 ? t('ATTR_BUTTON_BACK') : t('ATTR_BUTTON_CANCEL')}
          </BeautyButton>
          <PrimaryButton
            isDark={isDark}
            size="s"
            className="order-3 md:order-3"
            label={
              currentStep === 3
                ? t('ATTR_BUTTON_CONFIRM')
                : t('ATTR_BUTTON_NEXT')
            }
            onClick={handleNextStep}
            disabled={attributes?.length === 0}
          />
          <Divider />
        </FooterWrapper>
      )}
    </>
  );
};

export default Footer;
